var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnTheWay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 11C5 7.13401 8.13401 4 12 4C15.866 4 19 7.13401 19 11C19 13.2061 17.6639 15.268 15.7951 16.8876L12.3537 19.8702C12.1507 20.0461 11.8493 20.0461 11.6463 19.8702L8.20492 16.8876C6.33607 15.268 5 13.2061 5 11ZM12 2C7.02944 2 3 6.02944 3 11C3 14.0264 4.80977 16.5918 6.89505 18.399L10.3365 21.3816C11.2912 22.209 12.7088 22.209 13.6635 21.3816L17.1049 18.399C19.1902 16.5918 21 14.0264 21 11C21 6.02944 16.9706 2 12 2ZM13.7071 8.29289L15.7071 10.2929C16.0976 10.6834 16.0976 11.3166 15.7071 11.7071L13.7071 13.7071C13.3166 14.0976 12.6834 14.0976 12.2929 13.7071C11.9024 13.3166 11.9024 12.6834 12.2929 12.2929L12.5858 12H9C8.44772 12 8 11.5523 8 11C8 10.4477 8.44772 10 9 10H12.5858L12.2929 9.70711C11.9024 9.31658 11.9024 8.68342 12.2929 8.29289C12.6834 7.90237 13.3166 7.90237 13.7071 8.29289Z",
    fill: "#0A51C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnTheWay);
export default __webpack_public_path__ + "static/media/on-the-way.98f955485f37a6d8caaacd6096641886.svg";
export { ForwardRef as ReactComponent };